<!-- Button to trigger the Excel export -->
<!-- <button (click)="exportToExcel()" class="btn btn-added" [disabled]="data.length === 0">Download</button> -->

<a href="javascript:void(0)" (click)="exportToExcel()" [class.disabled]="data.length === 0" [attr.aria-disabled]="data.length === 0 ? 'true' : null" class="text-black">XLSX</a>